export default "__VITE_ASSET__fe32c92a__"